export const getters = {
  categoryList: state => state.category,
  categoryValue: state => state.categoryValue
};
